module.exports = __webpack_public_path__ + "img/1x.42bf57b.jpg";